import styled from 'styled-components'

import { navDropdownShadow } from '@syconium/little-miss-figgy/dist/utility-classes'

import { PrimaryNavLocalizationDialogContent } from '../../../app/_components/chrome/PrimaryNavLocalization.client'

// Positions the dropdown correctly to the left and inline with the text
export const Wrapper = styled.div`
  inset-inline-end: 14px;
  position: absolute;
  background-color: ${o => o.theme.color.deprecated.white.primary};
  ${navDropdownShadow}
  padding: ${o => o.theme.spacing(4)};
`

export function NavRegionLocaleSection() {
  return (
    <Wrapper>
      <PrimaryNavLocalizationDialogContent variant='form-only' />
    </Wrapper>
  )
}
